import { useAuthBootstrap } from "~/composables/useAuthBootstrap";

export default defineNuxtPlugin((nuxtApp) => {
  const handleUnauthorized = () => {
    const { markUnauthorized, rememberReturnTo } = useAuthBootstrap();
    markUnauthorized();
    const currentPath = nuxtApp.$router?.currentRoute.value.fullPath;
    if (currentPath) {
      rememberReturnTo(currentPath);
      nuxtApp.$router?.push({
        path: "/login",
        query: { redirect: currentPath },
      });
      return;
    }
    nuxtApp.$router?.push("/login");
  };

  const callOneCApi = async (
    action: string,
    payload: Record<string, any> = {},
  ) => {
    const body = { ...payload, action };

    try {
      return await $fetch("/api/modules", {
        method: "POST",
        body,
        credentials: "include",
      });
    } catch (error: any) {
      const status =
        error?.status || error?.statusCode || error?.response?.status;
      if (process.client && status === 401) {
        handleUnauthorized();
      }
      throw error;
    }
  };

  const downloadOneCApi = async (
    action: string,
    payload: Record<string, any> = {},
  ) => {
    const body = { ...payload, action };

    try {
      const response = await fetch("/api/modules", {
        method: "POST",
        body: JSON.stringify(body),
        credentials: "include",
        headers: {
          "Content-Type": "application/json",
        },
      });

      if (!response.ok) {
        const errorText = await response.text().catch(() => "");
        const error: any = new Error(errorText || "Failed to download file");
        error.status = response.status;
        error.statusCode = response.status;
        throw error;
      }

      return await response.json();
    } catch (error: any) {
      const status =
        error?.status || error?.statusCode || error?.response?.status;
      if (process.client && status === 401) {
        handleUnauthorized();
      }
      throw error;
    }
  };

  return {
    provide: {
      useOneCApi: callOneCApi,
      downloadOneCApi,
    },
  };
});
